import { SxProps, Theme } from "@mui/material"

export const dialogWrapper: SxProps<Theme> = {
  "& .MuiPaper-root": {
    borderRadius: "16px",
    width: "calc(100% - 32px)",
    margin: "16px",
  },
}

export const dialogIconClose: SxProps<Theme> = {
  position: "absolute",
  right: 8,
  top: 8,
  color: "#7C7C7C",
}

export const dialogTitle: SxProps<Theme> = {
  padding: "16px 24px",
  backgroundColor: "white",
  borderRadius: "16px 16px 0 0",
  fontSize: { xs: "16px", sm: "18px" },
  color: "#212134",
  borderBottom: "1px solid #E4EBE0",
}

export const dialogContent: SxProps<Theme> = {
  padding: { xs: "16px 12px", sm: "32px" },
}

export const dialogActions: SxProps<Theme> = {
  justifyContent: "center",
  padding: "16px 24px",
}
